import { CSSProperties, memo, useMemo } from "react";
import clsx from "clsx";
import { DevelopmentType } from "@gql/sites-api/graphql";
import { getDevelopmentTypeGradientClass } from "react-migration/domains/workspaces/util/getDevelopmentTypeGradientClass";

type WorkspaceHatchProps =
  | {
      size: "sm" | "md";
      loading: true;
      image?: never;
      imageSrc?: never;
      developmentType?: never;
    }
  | {
      size: "sm" | "md";
      loading?: false;
      image?: string | null;
      imageSrc?: string | null;
      developmentType: DevelopmentType[];
    };

export const WorkspaceHatch = memo(
  ({ size, imageSrc, developmentType, loading }: WorkspaceHatchProps) => {
    const backgroundStyle = useMemo<CSSProperties>(() => {
      if (imageSrc) {
        return { backgroundImage: `url(${imageSrc})`, backgroundSize: "cover", backgroundPosition: "center" };
      }

      return {};
    }, [imageSrc]);

    return (
      <div
        className={clsx("rounded-sm border border-neutral-200", "shrink-0 grow-0", {
          "h-5 w-5": size === "sm",
          "h-10 w-10": size === "md",
          "bg-background-surface-neutral-subtle animate-pulse": loading,
          [getDevelopmentTypeGradientClass(developmentType?.at(0) as DevelopmentType)]: !loading && developmentType,
        })}
        style={backgroundStyle}
      />
    );
  },
  // This prevents the component from re-rendering when the imageSrc changes (since is a signed URL), but the underlying image ID is the same.
  (prevProps, nextProps) => {
    return (
      prevProps.developmentType === nextProps.developmentType &&
      prevProps.loading === nextProps.loading &&
      prevProps.image === nextProps.image
    );
  }
);

WorkspaceHatch.displayName = "WorkspaceHatch";
